import { render, staticRenderFns } from "./PermanentToken.vue?vue&type=template&id=194baad7"
import script from "./PermanentToken.vue?vue&type=script&lang=js"
export * from "./PermanentToken.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports